import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable()

export class CustomAdminService {

    constructor(private http: HttpClient) { }
    scpBaseUrl = environment.scpCommonApiBaseUrl.url
    private createHttpOptions(token: string, name: string, firstName?: string, role?: string) {
        const headersObj: Record<string, string> = {
            'Content-Type': 'application/json',
            'token': token,
            'name': name,
        };

        if (role) {
            headersObj['role'] = role;
        }

        if (firstName) {
            headersObj['firstName'] = firstName;
        }
        return {
            headers: new HttpHeaders(headersObj),
        };
    }


    private getBaseURI(): string {
        return environment.rmpEndPointUser.url + '/custom/customProviderDetails';
    }

    getCustomAdminproviderDetails(token: string, name: string): Observable<any> {
        const URI = this.getBaseURI();
        const httpOptions = this.createHttpOptions(token, name);
        return this.http.get<any>(URI, httpOptions);
    }

    createCustomAdminproviderDetails(token: string, provider: string, signUpInfo: any, name: string, firstName?: string, role?: string): Observable<any> {
        const URI = this.getBaseURI();
        const httpOptions = this.createHttpOptions(token, name, firstName, role);
        return this.http.post<any>(URI, signUpInfo, httpOptions);
    }

    checkUserInSCP(userName: string) {
        const scpUrl = this.scpBaseUrl + `/identity/user/info?username=${userName}`
        return this.http.get<any>(scpUrl, {
            headers: {
                'Authorization': 'No Auth'
            }
        })
    }

    UpdateScpUser(token: string){
        const scpUrl = this.scpBaseUrl + `/identity/user/updatestatusverified?token=${token}`
        return this.http.post<any>(scpUrl, null, {
            headers: {
                'Authorization': 'No Auth'
            }
        }
        )
    }
}